import { PDF_TOOLS, type PdfToolId } from '@/data/pdfTools';
import { usePdfStore } from '@/stores/pdfStore';

const ICONS: Record<PdfToolId, string> = {
  pointer: '↖',
  text: 'T',
  highlight: '▮',
  brush: '✎',
  eraser: '⌫',
  image: '▣',
  shapes: '◯',
  sign: '✍',
  hand: '✋',
};

interface PdfMobileToolsMenuProps {
  busy?: boolean;
}

/** Top scrollable tools plate for phone layout. */
export default function PdfMobileToolsMenu({ busy }: PdfMobileToolsMenuProps) {
  const tool = usePdfStore((s) => s.tool);
  const setTool = usePdfStore((s) => s.setTool);

  return (
    <nav className="pdfe-mobile-tools" aria-label="PDF tools">
      <div className="pdfe-mobile-tools-scroll" role="toolbar">
        {PDF_TOOLS.map((t) => {
          const short =
            t.id === 'pointer'
              ? 'Select'
              : t.id === 'text'
                ? 'Text'
                : t.id === 'highlight'
                  ? 'Mark'
                  : t.id === 'hand'
                    ? 'Pan'
                    : t.label.split(' ')[0];
          return (
            <button
              key={t.id}
              type="button"
              className={`pdfe-mobile-tool${tool === t.id ? ' is-active' : ''}`}
              onClick={() => setTool(t.id)}
              disabled={busy}
              title={t.label}
              aria-pressed={tool === t.id}
            >
              <span className="pdfe-mobile-tool-icon" aria-hidden>
                {ICONS[t.id]}
              </span>
              <span>{short}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
